import { createContext, useContext, useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(localStorage.getItem("aa_theme") || "light");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("aa_theme", theme);
  }, [theme]);
  return <ThemeCtx.Provider value={{ theme, dark: theme === "dark", toggle: () => setTheme(theme === "dark" ? "light" : "dark") }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);

export const ThemeToggle = ({ light, className = "" }) => {
  const { dark, toggle } = useTheme();
  return (
    <button onClick={toggle} data-testid="theme-toggle" title={dark ? "Light theme" : "Dark theme"}
      className={`flex h-9 w-9 items-center justify-center rounded-full transition-colors ${light ? "bg-white/10 text-white hover:bg-white/20" : "bg-slate-100 text-slate-600 hover:text-slate-900"} ${className}`}>
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};
